import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const ProductsPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        All Products
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Products page coming soon...
      </Typography>
    </Container>
  );
};

export default ProductsPage;
